import { baseApi } from "./baseApi";

const API_CREDENTIAL_URL = "/api-credential";

export const apiCredentialApi = baseApi.injectEndpoints({
  tagTypes: ["API_CREDENTIAL"],

  endpoints: (builder) => ({
    apiCredentialDetail: builder.query({
      query: (sourceRef) => `${API_CREDENTIAL_URL}/sources/${sourceRef}`,
      providesTags: (_, __, id) => [{ type: "API_CREDENTIAL", id }],
    }),

    createApiCredential: builder.mutation({
      query: () => ({
        url: API_CREDENTIAL_URL,
        method: "POST",
      }),
    }),

    updateApiCredential: builder.mutation({
      query: (payload) => {
        const { credentialId, ...body } = payload;

        return {
          url: `${API_CREDENTIAL_URL}/${credentialId}`,
          method: "PATCH",
          body,
        };
      },
      invalidatesTags: (_, __, { _id }) => [
        { type: "API_CREDENTIAL", id: _id },
      ],
    }),
  }),
});

export const {
  useApiCredentialDetailQuery,

  useCreateApiCredentialMutation,

  useUpdateApiCredentialMutation,
} = apiCredentialApi;
